import { render, staticRenderFns } from "./GaleriTanimla.vue?vue&type=template&id=81432bc2&scoped=true&"
import script from "./GaleriTanimla.vue?vue&type=script&lang=js&"
export * from "./GaleriTanimla.vue?vue&type=script&lang=js&"
import style0 from "./GaleriTanimla.vue?vue&type=style&index=0&id=81432bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81432bc2",
  null
  
)

export default component.exports